module.exports = __webpack_public_path__ + "img/water_level_mid.b580d710.svg";